import { Pipe, PipeTransform } from '@angular/core';
import { CommentModel, isIframeComment } from '@dta/shared/models-api-loop/comment/comment.model';

@Pipe({
  name: 'isIframeComment',
  standalone: false
})
export class IsIframeCommentPipe implements PipeTransform {
  transform(comment?: CommentModel): boolean {
    return comment && isIframeComment(comment);
  }
}
